import {useState} from 'react'
import useApi from '../../../services/useApi'

export default function useProductBadgesOperations() {
  const [isLoading, setLoading] = useState(false)
  const Api = useApi()

  const deleteProductBadge = (badgeId: string) => {
    return Api.delete(
      `/products/product-badges`,
      {ids: [badgeId]},
      {
        setLoading,
        successMessage: 'Product badge deleted successfully',
        refetch: 'product-badges-list',
      }
    )
  }

  const toggleProductBadgeStatus = (badgeId: string, status: string) => {
    return Api.patch(
      `/products/product-badges/${badgeId}`,
      {is_active: status === 'active' ? true : false},
      {
        setLoading,
        successMessage: `Product badge ${
          status === 'active' ? 'activated' : 'deactivated'
        } successfully`,
        refetch: 'product-badges-list',
      }
    )
  }

  return {
    deleteProductBadge,
    toggleProductBadgeStatus,
    isOperationLoading: isLoading,
  }
}
